<template>
  <div class="userinfo-main">
      <div class="head">
          <img :src="info.headimgurl" alt="">
          <h3>{{info.nickname}}</h3>
      </div>
      <!--  -->
      <div class="content">
          <h4>已购票信息</h4>
          <div @click="showProductSucc(item)" v-for="(item,index) in list" :key="index" class="list">
            <div class="title">{{item.product_name}}</div>


            <div class="row"><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">{{item.province+' '+item.city+' '+item.district}}</div>

            <div class="row" v-show="item.product_id!=242">
              <img class="img2" src="@a/be-myself/2020/time.png" alt="">做自己节：12月28日·{{JSON.parse(item.product_detail)?JSON.parse(item.product_detail).createTime:''}}
            </div>

            <div class="row" v-show="item.product_id==240 || item.product_id==241 || item.product_id==242  || item.product_id==244 || item.product_id==2 || item.product_id==235">
              <img class="img2" src="@a/be-myself/2020/time.png" alt="">陈海贤工作坊：12月29日·9:00-12:30
            </div>
            <div class="row" v-show="item.product_id==239 || item.product_id==241 || item.product_id==242 || item.product_id==243 || item.product_id==2 || item.product_id==235">
              <img class="img2" src="@a/be-myself/2020/time.png" alt="">古典工作坊：12月29日·14:00-17:30
            </div>

            <div class="row" v-show="item.product_id!=238 && item.product_id!=239 && item.product_id!=240 && item.product_id!=241 && item.product_id!=242 && item.product_id!=243 && item.product_id!=244"><img class="img1" src="@a/be-myself/2020/user.png" alt="">负责人：{{item.product_user_list[0].user_name}}({{item.product_user_list[0].user_phone}})</div>

            <div class="row" v-show="item.product_id==238 || item.product_id==2 || item.product_id==235"><img class="img1" src="@a/be-myself/2020/user.png" alt="">添加小询(长按识别下方二维码添加)</div>
            <div class="row" v-show="item.product_id==238|| item.product_id==2 || item.product_id==235"><img style="width:200px;height: 200px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode.jpg" alt=""></div>


            <div class="row" v-show="item.product_id==239 || item.product_id==240 || item.product_id==241 || item.product_id==242 || item.product_id==243 || item.product_id==244 || item.product_id==2 || item.product_id==235"><img class="img1" src="@a/be-myself/2020/user.png" alt="">添加小鹿(长按识别下方二维码添加)</div>
            <div class="row" v-show="item.product_id==239||item.product_id==2||item.product_id==235"><img style="width:200px;height: 200px;" src="https://misc.xjy.cn/zuoziji/qr239.png" alt=""></div>
            <div class="row" v-show="item.product_id==240||item.product_id==2||item.product_id==235"><img style="width:200px;height: 200px;" src="https://misc.xjy.cn/zuoziji/qr240.png" alt=""></div>
            <div class="row" v-show="item.product_id==241||item.product_id==2||item.product_id==235"><img style="width:200px;height: 200px;" src="https://misc.xjy.cn/zuoziji/qr241.png" alt=""></div>
            <div class="row" v-show="item.product_id==242||item.product_id==2||item.product_id==235"><img style="width:200px;height: 200px;" src="https://misc.xjy.cn/zuoziji/qr242.png" alt=""></div>
            <div class="row" v-show="item.product_id==243||item.product_id==2||item.product_id==235"><img style="width:200px;height: 200px;" src="https://misc.xjy.cn/zuoziji/qr243.png" alt=""></div>
            <div class="row" v-show="item.product_id==244||item.product_id==2||item.product_id==235"><img style="width:200px;height: 200px;" src="https://misc.xjy.cn/zuoziji/qr244.png" alt=""></div>


            <div class="row" v-show="item.product_id==238 && item.product_id==239 && item.product_id==240 && item.product_id==241 || item.product_id==2">校验码：{{item.code}}</div>

          </div>
      </div>
      <!-- 引入组件 -->
    <buying-tickets-success v-if="buyTikShow"  :oid="oid" :name="name" :phone="phone" :price="discount_price?discount_price/100:((item.price/100)>0?(item.price/100):0)" :itemObj="item" class="buy-scssess"></buying-tickets-success>
  </div>
</template>

<script>
import { shareCon } from "@/utils/wxconfig";
import { orderList,userInfo } from "@/api/be_myself"
import BuyingTicketsSuccess from "../buying_tickets_success/index"
export default {
    data(){
        return{
            loading: false,
            finished: false,
            error: false,
            list:[],
            pages:{
                page: 0,
                size: 10,
            },
            user_id:null,
            info:{},
            productUser:[],
            // 
            name:'',
            phone:null,
            item:{},
            coupon:'',
            discount_price:null,
            buyTikShow:false,
            oid:null
        }
    },
    components: {
        BuyingTicketsSuccess
    },
    methods:{
        // 显示购买成功信息
        showProductSucc(row){
            this.discount_price = row.product_price;
            this.item = row;
            this.oid = row.id;
            this.name = row.name;
            this.phone = row.phone;
            this.buyTikShow = true;
        },
        // 获取用户信息
        getUserInfo(){
            // 获取用户信息
            userInfo().then((data)=>{
                this.info = data;
                this.user_id = data.user_id;
                this.getListData();
            });
        },
        // 获取已购信息
        pullData(){
            if(this.user_id){
                this.getListData();
            }else{
                this.getUserInfo();
            }
        },
        // 获取列表信息
        getListData(){
             //调用加载中
            this.$emit('loadingHandle',true,"2025，自在做自己(σ≧∀≦σ)");
            this.pages.page += 1;
            let q = this.$route.query;
            let obj = {
                page:this.pages.page,  //页码，默认1
                size:this.pages.size,   //每页数量，默认10
                category_id:1,//做自己节传1
                status:1,
                user_id:this.user_id
            };
            orderList(obj).then((data)=>{
                    //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
                this.pages = data.pager;
                
                this.list = Array.from(new Set([...this.list,...data.list]));
                
                // 加载状态结束
                this.loading = false;

                // 数据全部加载完成
                if(data.pager.page_count == data.pager.page) {
                    this.finished = true;
                }
            }).catch(err=>{
                this.error = true;
            });
        }
    },
    created(){
        this.pullData();
        shareCon("beMyself", this);
    }
}
</script>
<style lang="scss">
    body{
        background-color: #ffffff;
    }
</style>
<style lang="scss" scoped>

.userinfo-main{
    display: flex;
    flex-direction: column;
    .buy-scssess{
        position: fixed;
        width: 100%;
        max-width: 750px;
        min-height: 100%;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 888;
        background-color: #F5F5F5;
    }
    .head{
        display: flex;
        flex-direction: column;
        align-items: center;
        // margin-bottom: 8px;
        background-color: #ffffff;
        padding: 30px 0;
        border-bottom: 8px solid #f0f0f0;
        img{
            width: 120px;
            height: 120px;
            border-radius: 50%;
        }
        h3{
            font-size: 32px;
            color: #333333;
            line-height: 48px;
            margin: 28px auto 0;
        }
    }
    .content{
        background-color: #ffffff;
        padding: 30px 24px;
        h4{
            font-size: 28px;
            font-weight: 600;
            color: #333333;
            line-height: 40px;
            margin-bottom: 30px;
        }
        .list{
            display: flex;
            flex-direction: column;
            padding: 24px;
            border-radius: 8px;
            border: 2px solid #E4E4E4;
            margin-bottom: 20px;
            .title{
                font-size: 28px;
                font-weight: 600;
                color: #333333;
                line-height: 40px;
                margin-bottom: 30px;
            }
            .row{
                display: flex;
                align-items: center;
                font-size: 28px;
                color: #333;
                margin-bottom: 24px;
                line-height: 40px;
                .img1{
                    width: 30px;
                    margin-right: 8px;
                }
                .img2{
                    width: 27px;
                    margin-right: 10px;
                }
            }
        }
    }
}
</style>